import React, { useState, useContext, useEffect } from 'react';
import { Layout, Menu, Switch } from 'antd';
import { ThemeContext } from '../../context/themeContext';
import { useTranslation} from 'react-i18next'
import { AuthContext } from '../../context/authContext';
import { withApollo } from '@apollo/react-hoc';
import { OrgInfoContext } from '../../context/orgInfoContext';


const { Header} = Layout;

// const style={
//     iconStyle:{
//       fontWeight:800,
//       fontSize:20
//     }
//   }

  // const logout = () => {
  //   // localStorage.removeItem("user");
  //   // localStorage.removeItem("firstVisit");
  //   Auth.signOut().then((data) => {
  //     console.log(data)
  //     window.location.href='/'
  //     // window.location.reload(true)
  //   });
  // };




const MainHeader = (props) => {


  const context = useContext(OrgInfoContext)
  const authContext = useContext(AuthContext)

  // const [collapsed, setCollapsed] = useState(true);
  const [docId, setdocId] = useState(null)
  const [flag, setflag] = useState(false)



  useEffect(() => {
    if(context.docInfo !=null){
        setdocId(context.docInfo.email)
      }

  }, [context])

  useEffect(()=>{
    let themeFlag = localStorage.getItem('theme')
    if(themeFlag && themeFlag == 'dark'){
      setflag(true)
    }
  },[])


  const onChange =()=>{
    setflag(!flag)
    if(!flag == true){
      localStorage.setItem('theme','dark')
    }else{
      localStorage.removeItem('theme')
    }
      // var fileref = document.createElement("link");
      // fileref.rel = "stylesheet";
      // fileref.type = "text/css";
      // fileref.href = "/assets/theme.css";
      // document.getElementsByTagName("head")[0].appendChild(fileref)
  }

  return (
    <ThemeContext.Consumer>
      {({ theme1 }) => {
        return (
         
            <Header className="header"
              style={{ background: '#ffffff', paddingLeft: 20,
              padding:0, lineHeight:'48px',height:'48px', 
              // boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.05)', 
              zIndex: 1000 }}
            >

{/* --------------- DARK THEME IMPLEMENTATION -------------- */}

              {flag == true && 
                        <style jsx global>
                  {`
                    :root {
                      --main-chatui-color: #252525;
                      --main-bg-color: #080808;
                    }
                `}
            </style>
              }
          


          <Menu mode="horizontal">
              {/* <Menu.Item> 
                <MenuOutlined
                  style={{ color: 'rgba(0,0,0,.65)', fontSize: 15, display: 'inline-block', marginRight: 20 }}
                  onClick={() => {
                    props.setCollapsed(!props.collapsed)
                  }} />
                  </Menu.Item> */}
                  <Menu.Item>
                  <h3 style={{  marginRight: 20, margin:0 }}>{props.heading ? props.heading : authContext.data == null ? 'Internal Admin' : authContext.data.orgName ? authContext.data.orgName : ''}</h3>
                  </Menu.Item>
                 
                    {/* <Menu.Item style={{float:'right'}}>
                    <GlobalOutlined style={{ marginRight: 0 }} />
                        <Select bordered={false} defaultValue={currLang} onChange={(value) => {
                          handleChange(value)
                        }}>
                          <Option value="en">EN</Option>
                          <Option value="hi">HI</Option>
                        </Select>
                    </Menu.Item> */}
            
                  {/* <Menu.Item style={{float:'right'}}>
                  <Link to='/editProfile'>

              <UserOutlined style={{fontSize:'18px'}}/>
  
              </Link>
                  </Menu.Item> */}
                  {/* <Menu.Item style={{float:'right'}}>
                    {docId != null && context.isDoctor == true && 
                      <NotificationComp docId={docId}/>
                    }
                  </Menu.Item> */}
               
               <Menu.Item>
                  <Switch id='flagChnge' checked={flag} onChange={onChange} />
                </Menu.Item>

            </Menu>
              {/* <Link to='/'>
                <div className="logo" >
                  <img src={logo} style={{ width: 180, height: 'auto', marginBottom: 30 }} />
                </div>
              </Link> */}
              {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'space-between' }}> */}
              {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' , justifyContent:'center'}}>

                <MenuOutlined
                  style={{ color: 'rgba(0,0,0,.65)', fontSize: 15, display: 'inline-block', marginRight: 20 }}
                  onClick={() => {
                    props.setCollapsed(!props.collapsed)
                  }} />
                <h2 style={{ color: 'rgba(0,0,0,.65)', marginRight: 20, margin:0 }}>{props.heading ? props.heading : 'pms'}</h2>
             
              </div> */}
              {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}> */}

             
                {/* <OrgInfoContext.Consumer>
                  {(value)=>{
                    // console.log('heder update',value)
                    return(
                      <Select 
                      style={{width:200,marginRight:20}}
                      value={value.docInfo != null ? value.docInfo.email : null} 
                      onChange={(value) => {
                        // handleChange(value)
                      }}>
                        {value.docList && 
                        value.docList.map((item)=>{
                          return(
                            <Option value={item.email}>Dr {item.fName} {item.lName}</Option>
                          )
                        })}
                  
                      </Select>
                    )
                  }}
                </OrgInfoContext.Consumer> */}
                {/* {props.permissions && props.permissions.length > 0 && (props.permissions.indexOf('Admin') ==  -1 && props.permissions.indexOf('OrgAdmin') == -1) && 
                <RenderSelectCascader/>
                } */}
              {/* <div style={{marginRight:20, cursor:'pointer'}}
                  onClick={()=>{
                      logout()}}>
                  <LogoutOutlined style={style.iconStyle}/>
              </div> */}
            {/* 
              <Select defaultValue={'IND'} onChange={(value) => {
                handleChange(value)
              }}>
                {countryCodes.map((i)=>{
                  return(
                    <Option value={i}>{i}</Option>
                  )
                })}
              </Select> */}
               
              {/* <GlobalOutlined style={{ marginRight: 0 }} />
              <Select bordered={false} defaultValue={currLang} onChange={(value) => {
                handleChange(value)
              }}>
                <Option value="en">EN</Option>
                <Option value="hi">HI</Option>
              </Select>
              <Link to='/editProfile'>
              <Button style={{border:0}}>
              <UserOutlined />
              </Button>
              </Link>
              </div>
              </div> */}
              {/*   
              <Dropdown overlay={ProfileCard}>
                <Link to='/'>
                    <Button style={{border:0}}>
                      <DownOutlined />
                    </Button>
                  </Link>
                  </Dropdown> */}
                
            </Header>

        )
      }}
    </ThemeContext.Consumer>


  );
}
// IMP - PLEASE MAKE SURE THAT USE MEMO IS CHECKING ALL REQUIRED PROPS FOR CHANGE/UPDATE
function equalityCheckForProps(prevProps, nextProps) {
  return prevProps.menuS.length === nextProps.menuS.length && prevProps.collapsed == nextProps.collapsed
}

export default withApollo(React.memo(MainHeader))
